import { ModalProvider } from 'react-modal-hook';
import { ReactNode } from 'react';
import { useHistory } from 'react-router-dom';

import { FooterNav, NavBar, Wrapper } from '../Common/Layout';
import { defaultSecondary } from '../../theme/variables';
import { useAuth } from '../../common/Auth/useAuth';
import { useBrandColor } from '../../common/Common/ThemeProvider';
import { useNavigation } from '../Common/useNavigation';
import LocaleProvider from '../../common/LocaleProvider';
import UI from '../../common/UI';

export const PortalLayout = ({
  children,
}: {
  children?: ReactNode;
}) => {
  const { r } = useNavigation();
  const history = useHistory();

  useBrandColor(defaultSecondary);

  const { user } = useAuth({
    onUnauthenticated: () => {
      history.replace(r('Login', null, { withReturnUrl: true }));
    },
  });

  return (
    <LocaleProvider locale={user?.locale}>
      <ModalProvider>
        <Wrapper>
          <NavBar showFullLogo />

          {user && children}
          {!user && <UI.PageLoader />}

          <FooterNav hideAtletaMission />
        </Wrapper>
      </ModalProvider>
    </LocaleProvider>
  );
};

export default undefined;
